var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-home__section c-home__section--first c-home__section--active",attrs:{"data-home-section":_vm.sectionId}},[_c('HomeSectionContent',{attrs:{"sectionAttributes":_vm.sectionAttributes}}),_c('HomeSectionFooter',_vm._g({attrs:{"sectionAttributes":_vm.sectionAttributes,"sectionId":_vm.sectionId}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }